// console.log(`Analytics by Simple Integrated Marketing`);

const trackedLinks = [].slice.call(document.querySelectorAll(`[data-event]`));
const trackedForms = [].slice.call(document.querySelectorAll(`form`));

const handleClickTracking = item => {

	const clickEvent = (event) => {
		window.dl = window.dl || []
		window.dl.push({
			event: `simple_callToAction`,
			category: event.target.dataset.category,
			// element: event.target,
			elementLabel: event.target.innerHTML,
			elementValue: event.target.innerHTML || ``,
			// elementClasses: event.target.className || ``,
			// elementId: event.target.id || ``,
			// elementTarget: event.target.target || ``,
			// elementUrl: event.target.href || event.target.action || ``,
			// originalEvent: event
		});
	}
	
	item.addEventListener(`click`, clickEvent);
}

const handleFormSubmissionTracking = item => {

	const formSubmit = (event) => {
		window.dl = window.dl || []
		window.dl.push({
			event: `simple_formSubmit`,
		});
	}

	item.addEventListener(`submit`, formSubmit);

}

// Register the <a> click events for GTM
trackedLinks.map(item => handleClickTracking(item));

// Register the form submit event for GTM
trackedForms.map(item => handleFormSubmissionTracking(item));
